module.exports = __webpack_public_path__ + "static/img/health_bg.4e48951.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/health_bg.png
// module id = FOxX
// module chunks = 0